import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { FilterBarService } from '../../filter-bar-service/filter-bar.service';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-device-search',
  templateUrl: './device-search.component.html',
  styleUrls: ['./device-search.component.scss']
})
export class DeviceSearchComponent implements OnInit, OnDestroy {
  @Input() public searchData;
  @ViewChild('searchInput') searchInput: ElementRef;
  deviceSearchSubscription: ISubscription;
  label: String;
  deviceSearch: String;
  isActive: boolean = false;

  constructor(private _filter: FilterBarService) { }

  ngOnInit() {
    this.deviceSearchSubscription = this._filter.deviceSearch.subscribe((data: string) => {
      this.deviceSearch = data;
    });
   
    this.label = 'DEVICE NUMBER';
    this.isActive = false;
  }

  ngDoCheck() {
    let search: any = this.deviceSearch; 
    if (this.searchData == false) {
      // Reset handled by filter bar service
    } else {
      this.updateFilter(search);
    } 
  }

  ngOnDestroy() {
    this.deviceSearchSubscription.unsubscribe();
    this._filter.deviceSearchError = '';
  }

  showError() {
    return this._filter.deviceSearchError;
  }

  updateFilter(newSearch: string) {
    this._filter.deviceSearch.next(newSearch);
    this._filter.deviceSearchError = '';
  }
}
